/**
 * Created by ppatton on 12/21/2016.
 */
import { Injectable } from '@angular/core';

@Injectable()

export class LMStatePersistenceService {
  hasState(key: string): boolean {
    const cache = sscache.get(key);
    if (!cache || typeof cache !== 'object') {
      return false;
    }
    return true;
  }

  getState(key: string): object {
    const cache = sscache.get(key); // return sscache.get(key) || {};
    if (!cache || typeof cache !== 'object') {
      return {}; // safety
    }
    return cache;
  }

  /**
   * Save to session storage.
   * @param key - any unique string value
   * @param payload - must be a json object.
   */
  persistState(key: string, payload: object): void {
    sscache.set(key, payload);
  }

  removeState(key: string): void {
    sscache.remove(key);
  }
}
